import React, { createContext, useEffect, useState } from 'react';
import { currentHelpers } from '../../redirection/current';
import { gEnums } from '../../enums/globalEnums';

export const SearchParamContext = createContext();

const SearchParamProvider = (props) => {

  const hp = currentHelpers.getHashPath()
  const { queryValues } = hp ?? {}
  const { appViewMode } = queryValues ?? {}

  const [searchParam_state, set_searchParam_state] = useState({})

  useEffect(() => {
    if (appViewMode) {
      set_searchParam_state({ appViewMode, isGoogleSheetMode: appViewMode === gEnums.appViewModes.googleSheets })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [appViewMode]);

  const providerContext = () => <SearchParamContext.Provider value={{ searchParam_state }}>
    {props.children}
  </SearchParamContext.Provider>

  return providerContext()
}

export default SearchParamProvider